import { render, staticRenderFns } from "./CaseComponent.vue?vue&type=template&id=17469d88&scoped=true&"
import script from "./CaseComponent.vue?vue&type=script&lang=js&"
export * from "./CaseComponent.vue?vue&type=script&lang=js&"
import style0 from "./CaseComponent.vue?vue&type=style&index=0&id=17469d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17469d88",
  null
  
)

export default component.exports